
    import '/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider.en-US.md?watch=parent';
    export const demoIndex = {
  ids: ["docs-x-sdk-chat-provider-demo-basic","docs-x-sdk-chat-provider-demo-model","docs-x-sdk-chat-provider-demo-deepseek","docs-x-sdk-chat-provider-demo-openai-node"],
  getter: () => import(/* webpackChunkName: "meta__docs__en-US" */'/opt/buildhome/repo/packages/x/docs/x-sdk/chat-provider.en-US.md?type=demo')
};